import { ShipmentQuotation } from './+state/shipment-relations.models';
import {Observable} from "rxjs";

export abstract class ShipmentRelationsServiceBase {
    public abstract getShipmentQuotation(shipmentId: string): Observable<ShipmentQuotation>;
}
